import type { WhatsAppOnboardingConfigView } from '@hilo/contracts';

type Config = Extract<WhatsAppOnboardingConfigView, { enabled: true }>;
type Response = { authResponse?: { code?: string } };
type SDK = { init(options: Record<string, unknown>): void; login(callback: (response: Response) => void, options: Record<string, unknown>): void };
declare global { interface Window { FB?: SDK; fbAsyncInit?: () => void } }
let loading: Promise<SDK> | null = null;
let initialized: string | null = null;
export function loadWhatsAppSDK(config: Config): Promise<SDK> {
  const identity = config.appId + ':' + config.graphVersion;
  if (initialized && initialized !== identity) return Promise.reject(new Error('Recarga Hilo para actualizar la conexión con Meta'));
  if (!loading) loading = new Promise<SDK>((resolve, reject) => {
    const initialize = () => {
      if (!window.FB) return reject(new Error('Meta no pudo cargar su formulario'));
      window.FB.init({ appId: config.appId, autoLogAppEvents: false, xfbml: false, version: config.graphVersion });
      initialized = identity; resolve(window.FB);
    };
    if (window.FB) return initialize();
    window.fbAsyncInit = initialize;
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js'; script.async = true; script.crossOrigin = 'anonymous';
    const timer = window.setTimeout(() => reject(new Error('Meta tarda en responder. Vuelve a intentar.')), 15000);
    script.addEventListener('load', () => window.clearTimeout(timer), { once: true });
    script.addEventListener('error', () => { window.clearTimeout(timer); reject(new Error('No se pudo cargar Meta. Revisa la conexión.')); }, { once: true });
    document.head.append(script);
  }).catch(error => { loading = null; throw error; });
  return loading;
}
export function readWhatsAppFinish(event: Pick<MessageEvent, 'origin' | 'data'>): { wabaId: string; phoneNumberId?: string } | null {
  if (!['https://www.facebook.com', 'https://web.facebook.com', 'https://facebook.com'].includes(event.origin)) return null;
  let value: unknown;
  try { value = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch { return null; }
  if (!value || typeof value !== 'object') return null;
  const result = value as { type?: unknown; event?: unknown; data?: { waba_id?: unknown; phone_number_id?: unknown } };
  if (result.type !== 'WA_EMBEDDED_SIGNUP' || result.event !== 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING') return null;
  const wabaId = result.data?.waba_id; const phoneNumberId = result.data?.phone_number_id;
  if (typeof wabaId !== 'string' || !/^[0-9]{1,32}$/.test(wabaId)) return null;
  if (phoneNumberId !== undefined && (typeof phoneNumberId !== 'string' || !/^[0-9]{1,32}$/.test(phoneNumberId))) return null;
  return { wabaId, ...(phoneNumberId ? { phoneNumberId: phoneNumberId } : {}) };
}
/** Called synchronously by a user click after SDK + state preparation, preserving browser user activation. */
export function launchWhatsAppSignup(config: Config, onCode: (code: string | null) => void) {
  if (!window.FB || initialized !== config.appId + ':' + config.graphVersion) throw new Error('Meta todavía no está preparado');
  window.FB.login(response => {
    const code = response.authResponse?.code;
    onCode(typeof code === 'string' && /^[\x21-\x7e]{1,2048}$/.test(code) ? code : null);
  }, { config_id: config.configId, response_type: 'code', override_default_response_type: true,
    extras: { setup: {}, featureType: 'whatsapp_business_app_onboarding', sessionInfoVersion: '3' } });
}
